<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'AGENDA.LBL_INFOESTRUCTURA' | translate}}">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{estFisica.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{estFisica.estructuraFisica}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_DIRECCION' | translate }}:</label>
          <label class="lg:col-9 col-6 md:col-8"><strong>{{localizacion ? localizacion.direccion : ''}}</strong></label>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="grid">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'AGENDA.LBL_ZONA' | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8 "><strong>{{zona.nombre}}</strong></label>
        <label *ngIf="zona.nombreEjecutivo" class="lg:col-3 col-6 md:col-4 control-label">{{ 'AGENDA.LBL_EJECUTIVO' | translate }}
          :</label>
        <label *ngIf="zona.nombreEjecutivo" class="lg:col-3 col-6 md:col-8 "><strong>{{zona.nombreEjecutivo}}</strong></label>
      </div>
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-tabView (onChange)="cambioTabView($event)">
        <p-tabPanel *ngFor="let dia of dias; let i = index;let first = first;" header="{{ dia.encabezado | translate}}"
                    [selected]="tabSeleccionado === dia.codigo">
          <div class="grid" *ngIf="!dia.indPoligonos">
            <div class="col-12 md:col-12 lg:col-12">
              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                  <form [formGroup]="dia.formulario" (ngSubmit)="onSubmit(dia)">
                    <div class="grid form-group">
                      <div class="col-12 md:col-6 lg:col-6">
                        <div class="div-form">
                          <label for="barrios">* {{ 'AGENDA.LBL_BARRIO' | translate}}</label>
                          <p-dropdown disableTab  id="barrios" [options]="dia.items" formControlName="idZonaBarrio"
                                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                      optionValue="value"
                                      optionLabel="label"
                                      ></p-dropdown>
                          <div class="p-message p-messages-error p-corner-all"
                               *ngIf="dia.submitted && dia.formulario.controls.idZonaBarrio.invalid">
                            <i class="fa fa-close"></i>{{ 'AGENDA.MSG_BARREQUERIDO' | translate}}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 md:col-4 lg:col-4 text-md-right text-lg-right text-center">
                        <button class="p-button-datatables" pButton icon="fa fa-plus" label="{{ 'LBL_AGREGAR' | translate}}"
                                type="submit"></button>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-12 md:col-12 lg:col-12 text-center">
                  <div *ngIf="!procesando">
                    <p-table [columns]="columnas" [loading]="dia.cargando"
                             [value]="dia.datos" #dt
                             [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                      <ng-template pTemplate="header" let-columns>
                        <tr>
                          <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                              [pSortableColumnDisabled]="!col.sort"
                              class="text-center">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                          </th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-row>
                        <tr [pSelectableRow]="row">
                          <td>{{row.barrio}}</td>
                          <td>{{row.fragmento ? row.fragmento : ('LBL_NA' | translate)}}</td>
                          <td class="text-center">
                            <div class="btn-group" role="group">
                              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil"
                                      data-toggle="tooltip" *ngIf="row.indicadorDividirBarrio"
                                      title="{{'BTN_EDITAR' | translate}}" pButton
                                      (click)="editar(row, dia)"></button>
                              <button type="button" class="p-button p-button-danger btn" icon="fa fa-trash"
                                      data-toggle="tooltip"
                                      title="{{'BTN_DESHABILITAR' | translate}}" pButton
                                      (click)="deshabilitar(row, dia)"></button>
                            </div>
                          </td>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                          <td [attr.colspan]="columns.length" class="text-center">
                            {{ 'MSG_NOHAYREGISTROS' | translate}}
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                  <div *ngIf="procesando">
                    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
                    <span>{{'LBL_CONSULTANDO' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid" *ngIf="dia.indPoligonos">
            <div class="col-12 md:col-6 lg:col-6">
              <form [formGroup]="dia.forPoligonos" (ngSubmit)="guardarFragmento(dia)">
                <div class="grid form-group">
                  <div class="col-12 md:col-12 lg:col-12">
                    <div class="div-form">
                      <label>* {{ 'AGENDA.LBL_CODIGO' | translate }}</label>
                      <div *ngIf="!dia.fraSeleccionado">
                        <input type="text" pInputText id="codigo"
                               name="nomCodigo"
                               autocomplete="off"
                               formControlName="codigo"
                               maxlength="20"
                               (blur)="validarCodigo(dia)"
                               codigos-reactive
                        >
                        <div class="p-message p-messages-error p-corner-all"
                             *ngIf="dia.subPoligonos && dia.forPoligonos.controls.codigo.invalid">
                          {{ 'AGENDA.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                        </div>
                        <div class="p-message p-messages-error p-corner-all" *ngIf="dia.codExiste">
                          {{ 'MSG_CODIGOEXISTE' | translate}}
                        </div>
                      </div>
                      <div *ngIf="dia.fraSeleccionado && dia.fraSeleccionado.idAgendaFragmento">
                        <label class="falso-combo-texto">{{dia.fraSeleccionado.codigo}}</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid form-group">
                  <div class="col-12 md:col-12 lg:col-12">
                    <div class="div-form">
                      <label>* {{ 'AGENDA.LBL_NOMBRE' | translate }}</label>
                      <input type="text" pInputText id="nombre"
                             name="nomNombre"
                             autocomplete="off"
                             formControlName="fragmento"
                             [maxlength]="100"
                             capitalize-reactive
                      >
                      <div class="p-message p-messages-error p-corner-all"
                           *ngIf="dia.subPoligonos && dia.forPoligonos.controls.fragmento.invalid">
                        {{ 'AGENDA.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid form-footer-buttons">
                  <div class="form-group col-12">
                    <div *ngIf="!dia.cargando">
                      <a (click)="regFragmentos(dia.forPoligonos.dirty, dia)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                      <button icon="fa fa-plus" label="{{(dia.actualizar ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR') | translate }}"
                              type="submit"
                              pButton></button>
                    </div>
                    <div *ngIf="dia.cargando">
                      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                      <span>{{'LBL_GUARDANDO' | translate }}</span>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div id="mapa{{dia.indicador}}" style="width: 100%; height: 400px; position: relative; overflow: hidden;">
                <div class="text-center">{{ 'DIVISIONPOLITICA.LBL_SELECCIONDIVISION' | translate}}</div>
              </div>
            </div>
          </div>


        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>

</div>
<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
  size="medium"
  color="#58e175"
  type="timer"
></ngx-spinner>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
